export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["саны"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Аты"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Болдырмау"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сақтау"])}
}